import { TYPE_GRADE } from './configuration/actions';

export default (previousState = 'online', { type, payload }) => {
    if (type === TYPE_GRADE) {
        return payload;
    }
    return previousState;
};
